export const EF_TRACKING_URL = "https://www.ikd92trk.com?nid=1040"

export const NAME_GIBBERISH_WHITELIST = [
  'armstrong'
]